import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'OverlayButtonWrapper',
  props: {
    overlayClass: {}
  },
  setup(__props: any) {


const props = __props;

const overlayElement = ref<HTMLElement | null>(null);
const isOverlayVisible = ref(false);

const toggleOverlay = () => {
  if (!overlayElement.value) {
    overlayElement.value = document.querySelector(`.${props.overlayClass}`);
  }
  
  if (overlayElement.value) {
    isOverlayVisible.value = !isOverlayVisible.value;
    if (isOverlayVisible.value) {
      overlayElement.value.classList.remove('hidden');
    } else {
      overlayElement.value.classList.add('hidden');
    }
  }
};






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "overlay-button-wrapper",
    onClick: toggleOverlay
  }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})